import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-nosotros-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-nosotros-svg-icon.component.html',
  styleUrl: './ln-nosotros-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnNosotrosSvgIconComponent {
  @Input() class = 'w-4 h-5';
}
